import type { UserRoleName } from '../../types/auth';

interface UserRoleSelectProps {
  value: UserRoleName;
  onChange: (value: 'Editor' | 'Public User') => void;
  disabled?: boolean;
}

// Feature 011 — inline role dropdown. Admin is never offered (FR-004, FR-018).
//
// Feature 025 — nor is Super Editor: that role is assigned by migration to the one account that
// curates which hands go to Jeff, and the API refuses to change it either way. Such a row shows
// its role as fixed text rather than a dropdown, so the control never implies an edit the server
// would reject.
export function UserRoleSelect({ value, onChange, disabled }: UserRoleSelectProps) {
  if (value === 'Super Editor') {
    return (
      <span className="inline-block rounded-md border border-line-strong bg-cream px-2 py-1 text-sm text-ink-soft">
        Super Editor
      </span>
    );
  }

  return (
    <select
      value={value === 'Admin' ? 'Editor' : value}
      onChange={e => onChange(e.target.value as 'Editor' | 'Public User')}
      disabled={disabled}
      className="rounded-md border-line-strong text-sm shadow-sm focus:border-primary-500 focus:ring-primary-500 disabled:bg-cream disabled:text-ink-soft"
    >
      <option value="Editor">Editor</option>
      <option value="Public User">Public User</option>
    </select>
  );
}
